var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"cols":"12 px-0"}},[_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }